export default __webpack_public_path__ + "static/media/Leticia Jardim.3eb7b125.png";